import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
const steps = [{
  step: '01',
  title: 'Prescription criteria',
  body: 'What actually decides the script — ranked and weighted by the HCP, not by us.'
}, {
  step: '02',
  title: 'HCP perception',
  body: 'How every option on the shelf scores against those criteria, including ours.'
}, {
  step: '03',
  title: 'Our fact base',
  body: 'What Roche holds to be true and can defend on the same criteria.'
}, {
  step: '04',
  title: 'The gap',
  body: 'Perception subtracted from fact, weighted by how much each criterion matters.'
}];
export function FrameworkSlide() {
  return <SlideFrame marker="The Snakker approach" data-id="element-84" data-mp="1duxsjemjf9hw">
      <SlideTitle sub="Four inputs produce one number per criterion. That number, not an opinion, decides the route — and in practice it is usually a hybrid, weighted differently per segment." data-id="element-85" data-mp="3kkm0nvkaotn7">
        Four steps in, two routes — usually both
      </SlideTitle>

      <div className="mt-[3.5vh] grid shrink-0 grid-cols-4 gap-[2.5%]" data-id="element-86" data-mp="xcfh308srj1v">
        {steps.map(item => <article key={item.step} className="flex flex-col rounded-2xl border border-ink-line bg-paper-card px-[7%] py-[2.2vh]" data-id="element-87" data-mp="12bik6f57vf77">
            <span className="font-display text-[clamp(19px,2.5vw,42px)] leading-none text-gapAccent" data-id="element-88" data-mp="1c47vna0rot2j">
              {item.step}
            </span>
            <h3 className="mt-[1vh] text-[clamp(13px,1.5vw,25px)] font-semibold leading-[1.2] text-ink" data-id="element-89" data-mp="1l44f8x8av1qq">
              {item.title}
            </h3>
            <p className="mt-[0.8vh] text-[clamp(10px,1.12vw,18px)] leading-[1.45] text-ink-soft" data-id="element-90" data-mp="1q4ip8ktgolre">
              {item.body}
            </p>
          </article>)}
      </div>

      <div className="mt-[3.2vh] flex shrink-0 items-stretch gap-[2.5%]" data-id="element-91" data-mp="3rvcbfqxyg18d">
        <div className="flex w-[13%] items-center justify-end gap-[0.8vw] text-right" data-id="element-92" data-mp="nzpkym4mzm4">
          <span className="text-[clamp(10px,1.05vw,17px)] font-semibold uppercase tracking-[0.12em] text-ink-mute" data-id="element-93" data-mp="3oszdtmoxyjoo">
            Then the call
          </span>
          <ArrowRightIcon aria-hidden="true" className="h-[clamp(13px,1.5vw,24px)] w-[clamp(13px,1.5vw,24px)] shrink-0 text-gapAccent" data-id="element-94" data-mp="3jvfp1sumaoih" />
        </div>
        <div className="grid flex-1 grid-cols-3 gap-[2.5%]" data-id="element-95" data-mp="3tr0u5zuzg4wg">
          <div className="rounded-2xl bg-gapAccent px-[6%] py-[2.2vh]" data-id="element-96" data-mp="bmfp7musur98">
            <h3 className="text-[clamp(12px,1.45vw,24px)] font-semibold text-white" data-id="element-97" data-mp="bkcsyl3201w2">
              A — An education job
            </h3>
            <p className="mt-[0.6vh] text-[clamp(10px,1.05vw,17px)] leading-[1.45] text-white/80" data-id="element-98" data-mp="lcsa5g6j0mfw">
              The right HCPs, the wrong beliefs. Move the rating, or move the
              ranking.
            </p>
          </div>
          <div className="rounded-2xl border border-gapAccent/40 bg-paper-card px-[6%] py-[2.2vh]" data-id="element-99" data-mp="udqgi54ft61n">
            <h3 className="text-[clamp(12px,1.45vw,24px)] font-semibold text-ink" data-id="element-100" data-mp="qcmzhfanl3yu">
              B — A targeting job
            </h3>
            <p className="mt-[0.6vh] text-[clamp(10px,1.05vw,17px)] leading-[1.45] text-ink-soft" data-id="element-101" data-mp="18xt7o53z4zor">
              The beliefs are fair. Find the HCPs whose criteria already fit the
              brand.
            </p>
          </div>
          <div className="rounded-2xl bg-gapSoft px-[6%] py-[2.2vh]" data-id="element-102" data-mp="14xj1osg6m99w">
            <h3 className="text-[clamp(12px,1.45vw,24px)] font-semibold text-ink" data-id="element-103" data-mp="14zvk16puqlnh">
              A + B — A hybrid
            </h3>
            <p className="mt-[0.6vh] text-[clamp(10px,1.05vw,17px)] leading-[1.45] text-ink/75" data-id="element-104" data-mp="v0efwtq90ftm">
              The usual answer. Educate where the gap is winnable, target where
              it is not — segment by segment.
            </p>
          </div>
        </div>
      </div>
    </SlideFrame>;
}